export default __webpack_public_path__ + "static/media/storageUnit1-afterA-768w.91f3509a.webp";